import {Button} from 'components/system/button';
import {PlusSquare} from 'icons';
import {useAuth} from 'users';

export const SubmitQuestionButton = () => {
  const {user} = useAuth();
  return (
    <Button
      size='sm'
      type='outline'
      color='orange'
      icon={<PlusSquare color='orange' />}
      href={`https://airtable.com/shrH58eRnwZh4oVWZ?prefill_Email=${user.email}`}
      target='_blank'>
      Submit a question
    </Button>
  );
};
